import {FormError} from "@/components/ui/forms/FormError";
import {
  clearForm,
  sendReport,
  setError,
  setMessage,
  setTitle,
} from "@/redux/slices/commonSlices/requestSlice";

import {useEffect} from "react";

import {usePopup} from "@layouts/popup/InfoPopup/PopupContext";
import {SuccessSendPopup} from "@popups/attentionPopups/SuccessSendPopup";
import {RootButton} from "@ui/buttons/RootButton";
import {RootDesc} from "@ui/descriptions/RootDesc";
import {Spinner} from "@ui/general/Spinner";
import EditSelect from "@ui/inputs/EditSelect";
import {RootTextarea} from "@ui/inputs/RootTextarea";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import styles from "./styles.module.scss";

export const ReportPopup = ({options}) => {
  const {openPopup} = usePopup();
  const {title, message, error, status} = useSelector(
    (state) => state.common.request,
  );
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(setError(""));

    if (!message || !title) {
      dispatch(setError(t("server_error.fields")));
      return;
    }

    const resultAction = await dispatch(sendReport({title, message}));

    if (sendReport.fulfilled.match(resultAction)) {
      dispatch(clearForm());
      openPopup(<SuccessSendPopup />);
    } else {
      dispatch(setError(t("server_error.submit_data")));
    }
  };

  const handleSelect = (option) => {
    dispatch(setTitle(option.name));
  };

  useEffect(() => {
    dispatch(setError(""));
  }, [title, message]);

  useEffect(() => {
    return () => {
      dispatch(clearForm());
    };
  }, []);

  return (
    <div className={styles.report}>
      <H3>{t("popup.report.title")}</H3>

      <form
        onSubmit={handleSubmit}
        className={styles.reportForm}
      >
        <div className={styles.input}>
          <div className={styles.input_grid}>
            <RootDesc>
              <b
                dangerouslySetInnerHTML={{
                  __html: t("input.report_what_issue"),
                }}
              />
            </RootDesc>

            <EditSelect
              height={200}
              width={350}
              options={options}
              onSelect={(selectedOption) => handleSelect(selectedOption)}
              placeholder={t("input.report_what_issue_placeholder")}
            />
          </div>
        </div>

        <div className={styles.input}>
          <RootTextarea
            placeholder={t("input.report_issue_placeholder")}
            label={t("input.report_issue")}
            type={"text"}
            value={message}
            required
            onChange={(e) => dispatch(setMessage(e.target.value))}
            disabled={status === "loading" && true}
          />
        </div>

        <RootButton
          txt={t("button.submit")}
          type={"submit"}
          disabled={!title || !message || status === "loading"}
        />

        {error !== "" && (
          <FormError
            error={error}
            bottom={105}
          />
        )}

        {status === "loading" && (
          <Spinner
            width={50}
            height={50}
          />
        )}
      </form>
    </div>
  );
};
